import React from 'react';

const User = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "12",
    height: "18",
    viewBox: "0 0 12 18",
    fill: "none"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M6 8C8.20914 8 10 6.20914 10 4C10 1.79086 8.20914 0 6 0C3.79086 0 2 1.79086 2 4C2 6.20914 3.79086 8 6 8Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.3295 11.2071C7.9517 9.59762 4.07386 9.59762 1.67898 11.2071C0.596591 11.9427 0 12.9378 0 14.0022C0 15.0665 0.596591 16.053 1.67045 16.7799C2.86364 17.5933 4.43182 18 6 18C7.56818 18 9.13636 17.5933 10.3295 16.7799C11.4034 16.0443 12 15.0579 12 13.9849C11.9915 12.9205 11.4034 11.934 10.3295 11.2071Z",
      fill: "white"
    }
  )
);

export { User };
//# sourceMappingURL=User.js.map
